import type { UUID } from '@cmg/common';

type DeliveryInstrumentBase = {
  id: UUID;
  countryCode?: string | null;
};

export function getOfferingPricingCountryCode<TInstrument extends DeliveryInstrumentBase>({
  instruments,
  pricingInstrumentId,
}: {
  pricingInstrumentId: string | null | undefined;
  instruments: readonly TInstrument[] | null | undefined;
}) {
  return instruments?.find(instrument => instrument.id === pricingInstrumentId)?.countryCode;
}
